/* eslint-disable @typescript-eslint/naming-convention */
import { IntranetSingularRole } from '@howdeniberia/core-front';
import { UserRole } from '../enums/user-role.enum';

export const APP_ROLES = {
  ALL: [
    IntranetSingularRole.CompanyAdministrator,
    IntranetSingularRole.CompanyDirector,
    IntranetSingularRole.CompanyBackOffice,
    IntranetSingularRole.CompanyExecutive,
    UserRole.ArpaUnlimited,
    UserRole.ArpaCanSeeTrace,
    UserRole.ArpaPowersIT,
    UserRole.ArpaPowersLifePrebal,
    UserRole.ArpaPowersLifeSantaLucia
  ]
};
